// src/utils/txNotifications.js
// Browser Notification utility for transaction status updates.
// Works even when the user is in the wallet app (mobile).

let permissionGranted = false;

export async function requestNotificationPermission() {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') {
    permissionGranted = true;
    return true;
  }
  if (Notification.permission === 'denied') return false;

  const result = await Notification.requestPermission();
  permissionGranted = result === 'granted';
  return permissionGranted;
}

export function sendTxNotification(title, body, options = {}) {
  if (!('Notification' in window)) return;
  if (Notification.permission !== 'granted') return;

  try {
    const notification = new Notification(title, {
      body,
      icon: '/favicon.ico',
      badge: '/favicon.ico',
      tag: 'xcoin-tx',
      renotify: true,
      requireInteraction: options.persist || false,
      ...options
    });

    // Auto-close after 8 seconds unless persistent
    if (!options.persist) {
      setTimeout(() => notification.close(), 8000);
    }

    // Focus window when tapped on mobile
    notification.onclick = () => {
      window.focus();
      notification.close();
    };
  } catch (e) {
    // Silent fail - notifications are best-effort
    console.warn('[TxNotify] Failed:', e.message);
  }
}
